import React from 'react';

import { CSSInterpolation } from '@emotion/css/create-instance';
import { css } from '@emotion/react';
import { Modal, NeutralColorToken, TextButton, Type } from '@robinhood/design';

import Button from 'src/components/creditApplication/Button';

interface PropsIface {
  label?: string;
  overrideRootStyles?: CSSInterpolation;
}

const GetHelpTextButton = ({ label, overrideRootStyles }: PropsIface) => {
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const onShowModal = React.useCallback(() => {
    setShowModal(true);
  }, []);

  const onDismissModal = React.useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <>
      <TextButton
        label={label || 'Help'}
        color={NeutralColorToken.Fg2}
        variant='standalone'
        type='button'
        onClick={onShowModal}
        overrideRootStyles={[text, overrideRootStyles]}
      />
      {showModal && (
        <Modal width='wide' overrideModalStyles={root} onClose={onDismissModal}>
          <div css={textContainer}>
            <Type.Display size='S'>Contact support</Type.Display>
            <Type.Text size='M'>
              {'For assistance, contact the Robinhood Credit Card Support team at '}
              <TextButton
                label='apply@robinhood.com'
                type='anchor'
                href='mailto:apply@robinhood.com'
                color={NeutralColorToken.Fg1}
                variant='inline'
              />
            </Type.Text>
          </div>
          <Button label='Dismiss' width='full' type='button' onClick={onDismissModal} />
        </Modal>
      )}
    </>
  );
};

const text = css`
  text-align: center;
`;

const root = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px;
`;

const textContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

export default GetHelpTextButton;
